<template>
  <input type="text" v-model="input" @input="search" placeholder="e.g ingredients or type of food" />
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      input: "",
      filteredRecipes: []
    };
  },
  computed: {
    recipes() {
      return this.$store.getters.allRecipes;
    },
    searchWords() {
      return this.input.split(" ");
    }
  },
  methods: {
    search() {
      this.debounceSearch();
    },
    debounceSearch: _.debounce(function() {
      this.filteredRecipes = this.recipes;
      this.performSearch();
    }, 500),
    performSearch() {
      this.$store.commit('setSearchString', this.input);
      this.$store.commit("setSearch", this.searchWords);
      this.$store.dispatch("applyOrder", this.filteredRecipes);
    }
  },
  created () {
    this.input = this.$store.getters.searchString;
  },
};
</script>

<style>
</style>